import * as S from '../components/Static.styles'

const defaultProps = {}
const propTypes = {}

export const ContactUs = () => {
  return (
    <S.Article>
      <S.Header>
        <S.Title>Contact us</S.Title>
      </S.Header>
      <S.Content>
        <p>
          You can contact TrialSite at:{' '}
          <S.MailTo href="mailto:info@trialsitenews.com">
            <strong>info@trialsitenews.com</strong>
          </S.MailTo>
        </p>
        <p>
          TrialSite News
          <br />
          159 W Broadway, Suite 200
          <br />
          Salt Lake City, UT 84101
          <br />
        </p>
      </S.Content>
    </S.Article>
  )
}

ContactUs.defaultProps = defaultProps
ContactUs.propTypes = propTypes

export default ContactUs
